import type { Media, VideoContentObject } from 'models';
import { HeaderAsset } from 'ui';
import { images } from 'common/utils';
import { useVideoControl } from '../../context';

type P = {
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const VideoHeaderAsset = ({ trailerData, videoContentObject }: P) => {
  const { headerVideoRef } = useVideoControl();

  return (
    <HeaderAsset
      ref={headerVideoRef}
      {...(trailerData?.alts?.stream?.status === 'active'
        ? {
            video: {
              autoPlay: true,
              className: 'video-header-asset',
              muted: true,
              src: trailerData.alts.stream.path,
            },
          }
        : {
            image: {
              alt: 'Video cover photo',
              src: videoContentObject.video.coverPhoto?.url ?? images.default.videoCoverPhoto,
            },
          })}
    />
  );
};

export default VideoHeaderAsset;
